export const news = [
    {
        "id": "1",
        "title": "Cardata Web Sitesi Tasarımı Yenilendi",
        "text": "Cardata, web sitesinin tasarımını yenilerken, ikinci elde alım-satım işlerini kolaylaştıracak dikkat çekici yeni özellikleri Türkiye’de ilk kez kullanıcıların beğenisine sundu!"
    },
    {
        "id": "2",
        "title": "Dijital Dönüşüm",
        "text": "Cardata, otomotiv sektöründe Dijital Dönüşüm’e liderlik ediyor! Yeni Ürünümüz Araç Tedariği otomobil satıcılarının beğenisine sunuldu."
    },
    {
        "id": "v2o10",
        "title": "İstanbul Aydoğan Otomotiv",
        "text": "İstanbul Aydoğan Otomotiv Cardata Ailesine Hoşgeldiniz!"
    },
    {
        "id": "v2o11",
        "title": "Ankara Etimesgut - Çağ Otomotiv",
        "text": "Giresun Kaya Otomotiv Cardata Ailesine Hoşgeldiniz!"
    },
    {
        "id": "v2o12",
        "title": "Samsun - Azim Otomotiv",
        "text": "İstanbul Mızraklı Otomotiv Cardata Ailesine Hoşgeldiniz!"
    },
    {
        "id": "v2o13",
        "title": "Ankara Etimesgut - Çağ Otomotiv",
        "text": "İstanbul HemenSatMerkezi Cardata Ailesine Hoşgeldiniz!"
    },
    {
        "id": "v2o14",
        "title": "İstanbul Aydoğan Otomotiv",
        "text": "İstanbul Aykan Otomotiv Cardata Ailesine Hoşgeldiniz!!"
    },
    {
        "id": "v2o15",
        "title": "Ankara Etimesgut - Çağ Otomotiv",
        "text": "İstanbul Bacar Otomotiv Cardata Ailesine Hoşgeldiniz!"
    },
    {
        "id": "v2o16",
        "title": "Samsun - Azim Otomotiv",
        "text": "İstanbul Otostat Cardata Ailesine Hoşgeldiniz!"
    },
    {
        "id": "v2o17",
        "title": "Ankara Etimesgut - Çağ Otomotiv",
        "text": "Ankara Global Otomotiv Cardata Ailesine Hoşgeldiniz!"
    },
    {
        "id": "v2o18",
        "title": "Ankara Etimesgut - Çağ Otomotiv",
        "text": "İstanbul Otomerkezi Cardata Ailesine Hoşgeldiniz!"
    },
    {
        "id": "v2o19",
        "title": "Ankara Etimesgut - Çağ Otomotiv",
        "text": "İstanbul Alp Gülan Otomotiv Cardata Ailesine Hoşgeldiniz!"
    }
]